<template>
  <transition name="router-anim">
    <div class="kits">
      <div v-if="kitStatus === 'problematic' ">
        <div class="prob-count custom" v-if="report.total === sub_total">
          Total: {{ report.total }}
        </div>
        <div class="prob-count custom" v-else>
          {{ sub_total }} of {{ parseInt(problematictotal).toLocaleString() }} 
          Reports <span v-if="sub_total != 0">({{ ((100 * parseInt(sub_total)) / parseInt(problematictotal)).toFixed(2) }}%)</span>
        </div>
      </div>  
      <div v-else>
        <div class="prob-count custom" v-if="getSearchstr">
          Total: {{ sub_total }}
        </div>
        <div class="prob-count custom" v-else-if="report.total === sub_total">
          Total: {{ report.total }}
        </div>
        <div class="prob-count custom" v-else>
          {{ sub_total }} of {{ report.total }}
        </div>
      </div> 
      <div class="kits-title">
        <div class="title id">
          KIT ID
        </div>
        <div class="title type">
          TYPE
        </div>
        <div class="title status">
          STATUS
        </div>
        <div class="title date">
          DATE
        </div>
        <div class="title first-name">
           NAME
        </div>
        <div class="title email">
          EMAIL
        </div>
        <div class="title result" @click="sortedByResult">
          REPORT RESULT
           <img
            src="../../images/dashboard/up.png"
            alt="#"
            v-if="sortedByStateResult === 'desc'"
          />
          <img
            class="down"
            src="../../images/dashboard/down.png"
            alt="#"
            v-else
          />
        </div>
        <div class="title shipdate" @click="sortedBy">
          <span>SHIP DATE</span>
          <img src="../../images/dashboard/up.png" alt="#" v-if="sortedByState === 'desc'" />
          <img class="down" src="../../images/dashboard/down.png" alt="#" v-else />
        </div>
      </div>
      <div v-if="kits.length > 0">
        <div class="kits-item" v-for="item in kits" :key="item.id">
          <div
            class="kit-desc id"
            @click.stop="stopPropagation"
            @click="showModal(item.id, item.user_id, 'kit')"
          >
            {{ convertKitId(item.kit_id) }}
          </div>
          <div
            class="kit-desc type"
          >
            <span v-if="item.amazon_kits == 1"> Amazon</span>
            <span v-else>Woo</span>
          </div>
          <div
            class="kit-desc status"
            :style="
              item.status === 'on_hold' ? { color: 'rgb(232, 122, 1)' } : null
            "
          >
            <span class="onHoldStatus" v-if="item.status === 'on_hold'">
              On Hold
              <button
                @click.stop="stopPropagation"
                @click="showModal(item.id, item.user_id, 'hold')"
                class="onhold-btn"
              >
                <img
                  class="onhold-btn-img"
                  src="../../images/dashboard/onhold.png"
                  alt="#"
                />
              </button>
            </span>
            <span class="onHoldStatus" v-if="item.status === 'archive'">
              Archived
              <button
                @click.stop="stopPropagation"
                @click="showModal(item.id, item.user_id, 'archive')"
                class="onhold-btn"
              >
                <img
                  class="onhold-btn-img"
                  src="../../images/dashboard/onhold.png"
                  alt="#"
                />
              </button>
            </span>
            <span v-if="item.status === 'analysis_completed'"
              >Analysis Complete</span
            >
            <span v-if="item.status === 'analysis_failed'"
              >Analysis Failed</span
            >
            <span v-if="item.status === 'partially_failed'"
              >Analysis Partially Complete</span
            >
            <span v-if="item.status === 'lab_received'">Lab Received</span>
            <span v-if="item.status === 'lab_awaiting'">Submitted</span>
            <span v-if="item.status === 'shipped'">Shipped</span>
            <span v-if="item.status === 'activated'">Activated</span>
            <span v-if="item.status === 'delivered'">Delivered</span>
            <span v-if="item.status === 'in_active'">Inactive</span>
            <div
              class="status-line"
              :style="
                item.status === 'on_hold'
                  ? { backgroundColor: 'rgba(232, 122, 1, .4)' }
                  : null
              "
            >
              <div
                class="status-line-bg"
                :style="[
                  item.status === 'in_active' ? { width: '5%' } : null,
                  item.status === 'shipped' ? { width: '16.6%' } : null,
                  item.status === 'delivered' ? { width: '28.8%' } : null,
                  item.status === 'activated' ? { width: '49.8%' } : null,
                  item.status === 'lab_awaiting' ? { width: '66.4%' } : null,
                  item.status === 'lab_received' ? { width: '83%' } : null,
                  item.status === 'on_hold'
                    ? { width: '83%', backgroundColor: '#E87A01' }
                    : null,
                  item.status === 'analysis_failed'
                    ? { width: '100%', backgroundColor: 'red' }
                    : null,
                  item.status === 'partially_failed'
                    ? { width: '100%', backgroundColor: 'grey' }
                    : null,
                  item.status === 'analysis_completed' ? { width: '100%' } : null
                ]"
              ></div>
            </div>
          </div>
          <div class="kit-desc status-date">
            <span v-if="item.status === 'on_hold'">{{ date(item.onhold_at) }}</span>
            <span v-if="item.status === 'lab_received'">{{ date(item.received_at) }}</span>
            <span v-if="item.status === 'lab_awaiting'">{{ date(item.awaiting_at) }}</span>
            <span v-if="item.status === 'shipped'">{{ date(item.shipped_at) }}</span>
            <span v-if="item.status === 'activated'">{{ date(item.activated_at) }}</span>
            <span v-if="item.status === 'delivered'">{{ date(item.woo_delivered_date) }}</span>
            <span v-if="item.status === 'analysis_completed'">{{ date(item.reported_at) }}</span>
          </div>
          <div class="kit-desc first-name">
            <span> {{ item.collected_last_name }}, {{ item.collected_first_name }}</span>
          </div>
          <div class="kit-desc email" v-if="item.collected_email">
            <span>{{ item.collected_email }}</span>
          </div>
          <div class="kit-desc email" v-else>
            <span v-if="item.user">{{ item.user.email }}</span>
          </div>
          <div class="kit-desc result">
            <div v-if="item.status === 'analysis_completed'">
              <span
                class="status green"
                v-if="
                  item.result === 0"
                >Not Evident</span
              >
              <span
                class="status yellow"
                v-if="
                item.result === 1"
                >Slightly Evident</span
              >
              <span
                class="status orange"
                v-if="item.result === 2"
                >Moderately Evident</span
              >
              <span
                class="status red"
                v-if=" item.result === 3"
                >Significantly Evident</span
              >
            </div>
            <div v-else >
              <span>N/A</span>
            </div>
          </div>
          <div class="kit-desc date">
            {{ date(item.shipped_at) }}
          </div>
          <div class="kit-actions">
            <div class=" kit-desc edit-kit-btn" @click="edit(item)" title="Edit">
              <img src="../../images/dashboard/icons8-edit-100.png" />
            </div>
            <div title="Login As Customer" class="login-kit-btn" v-if="role === 'superadmin' && item.user !== null"
              @click="login(item.user)">
              <img src="../../images/dashboard/login.svg" alt="#" />
            </div>
            <div title="Archive" class="archive-kit-btn"
              v-if="role === 'superadmin' && item.status !== 'archive' && item.status !== 'on_hold'"
              @click="archive(item)">
              <img src="../../images/dashboard/archive-black.png" alt="#" />
            </div>
            <div title="Reset" class="erase-kit-btn"
              v-if="role === 'superadmin' && (item.status == 'shipped' || item.status == 'delivered')"
              @click="erase(item)">
              <img src="../../images/dashboard/icons8-rubber.png" />
            </div>
            <div title="Unarchive" class="archive-kit-btn"
              v-if="role === 'superadmin' && item.status === 'archive' && item.status !== 'on_hold'"
              @click="unarchive(item)">
              <img src="../../images/dashboard/unarchive.png" alt="#" />
            </div>
            <div title="Delete" class="remove-kit-btn" v-if="role === 'superadmin'" @click="remove(item)"></div>
          </div>
        </div>
      </div>
      <div v-else class="kits-item">
        <div class="kit-desc nodata">
          No Data Retrieved.
        </div>
      </div>
      <div class="pogination">
        <Paginate
          v-if="count_page > 1"
          :page-count="count_page"
          :page-class="'pogination-item'"
          :click-handler="changePage"
          :prev-text="'<'"
          :next-text="'>'"
          :container-class="'pogination-wrap'"
        ></Paginate>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapActions } from "vuex";
import { mapGetters } from "vuex";
import Paginate from "vuejs-paginate";
import moment from "moment";
import { parseAndConvertKitId } from "../mixins/parseAndConvertKitId";
import Remove from "../../images/dashboard/Remove";

export default {
  name: "Kits",
  mixins: [parseAndConvertKitId],
  data() {
    return {
      kits: [],
      count_page: 1,
      sortedByState: "desc",
      total_completed: 0,
      sortedByStateResult:"desc",
      kitStatus: null,
      report: {
        total: 0
      },
      sub_total: 0,
      problematictotal:0
    };
  },
  components: {
    Paginate,
    Remove
  },
  methods: {
    changePage(item) {
      this.setPginationPage(item).then(res => {
        this.sendSearchReq();
      });
    },
    ...mapActions([
      "testKitInfo",
      "getUserInfo",
      "sendSearchReq",
      "setSortedBy",
      "setOrderBy",
      "setPginationPage",
      "loginCustomer"
    ]),
    remove(item) {
      this.$emit("confurmDelKit", { show: true, id:item.id, kit_id:this.convertKitId(item.kit_id)  });
    },
    archive(item) {
      this.$emit("confurmArvKit", { show: true, id: item.id, title: item.title, kit_id:item.kit_id});
    },
    erase(item) {
      this.$emit("confirmEraseKit", { show: true, id: item.id, title: item.title, kit_id:item.kit_id});
    },
    unarchive(item) {
      this.$emit("confirmUnArvKit", { show: true, id: item.id, title: item.title, kit_id:item.kit_id});
    },
    async edit(item) {
      await this.testKitInfo(item.id);
      this.$emit("editKit", { show: true});
    },
    login(user) {
      this.$emit("confirmCusLogin", { show: true, user:user});
    },
    sortedBy() {
      if (this.sortedByState === "desc") {
        this.sortedByState = "asc";
      } else {
        this.sortedByState = "desc";
      }
      this.setOrderBy("shipped_at");
      this.setSortedBy(this.sortedByState).then(() => {
        this.sendSearchReq();
      });
    },
    sortedByResult() {
        if (this.sortedByStateResult === "desc") {
          this.sortedByStateResult = "asc";
        } else {
          this.sortedByStateResult = "desc";
        }
        this.setOrderBy("result");
        this.setSortedBy(this.sortedByStateResult).then(() => {
          this.sendSearchReq();
        });
      },
    makePhone(phone) {
      const phoneArr = phone.split("");
      return `(${phoneArr[1]}${phoneArr[2]}${phoneArr[3]}) ${phoneArr[4]}${
        phoneArr[5]
      }${phoneArr[6]}-${phoneArr[7]}${phoneArr[8]}${phoneArr[9]}${
        phoneArr[10]
      }`;
    },
    showModal(kitId, userId, modal) {
      this.testKitInfo(kitId).then(res => {
        if (modal === "kit") {
          if (userId !== null) {
            this.getUserInfo(userId).then(res => {
              this.$emit("showModal", true);
            });
          } else {
            this.$emit("showModal", true);
          }
        } else if (modal === "hold") {
          this.$emit("showComment", {
            txt: this.$store.getters.getTestKitInfo.reason_on_hold,
            show: true,
            id: this.$store.getters.getTestKitInfo.id
          });
        }
        else if (modal === "archive") {
          this.$emit("showCommentArchive", {
            txt: this.$store.getters.getTestKitInfo.reason_archive,
            show: true,
            id: this.$store.getters.getTestKitInfo.id
          });
        }
      });
    },
    date(localDate) {
      if (localDate !== null) {
        var todayDate = localDate.slice(0, 10);
        let d = todayDate.split("-");
        let dates = d[1] + '/' + d[2] + '/' + d[0];
        return dates;   
      }
    },
    stopPropagation(event) {
      event.stopPropagation();
    }
  },
  computed: {
    ...mapGetters(["getAdminKits", "pogination", "role", "completedKitCount", "kitsSubTotal", "adminReport", "getSearchstr"])
  },
  watch: {
    getAdminKits(obj) {
      this.kits = obj;
      this.total_completed = this.$store.getters.completedKitCount;
      this.sub_total = this.$store.getters.kitsSubTotal;
      this.kitStatus = this.$store.getters.getKitStatus;
      this.problematictotal = this.$store.getters.completedKitCount;
    },
    pogination(num) {
      this.count_page = num;
    },
    adminReport(obj) {
      for (var k in obj) {
        if (this.report.hasOwnProperty(k)) {
          this.report[k] = Number(obj[k]);
        }
      }
    }
  },
  mounted() {
    if(this.$store.getters.adminReport != null) {
      this.report.total = Number(this.$store.getters.adminReport.total);
    }
    if (this.$store.getters.getAdminKits) {
      this.kits = this.$store.getters.getAdminKits;
      this.kitStatus = this.$store.getters.getKitStatus;
      this.total_completed = this.$store.getters.completedKitCount;
      this.sub_total = this.$store.getters.kitsSubTotal;
    }
    if (this.$store.getters.pogination !== null) {
      this.count_page = this.$store.getters.pogination;
    }
    // this.sendSearchReq();
  }
};
</script>

<style scoped lang="scss">
.kits {
  margin: 15px 0 0 0;
}
.kits-title {
  display: flex;
  justify-content: space-between;
  margin: 0 0 20px 0;
  padding: 0 30px;
}
.title {
  color: #b3b3b3;
  font-size: 12px;
  font-family: TTNormsMedium, sans-serif;
}
.title.id {
  min-width: 130px;
  width: 100%;
  max-width: 130px;
}
.kit-desc.id {
  min-width: 128px;
  width: 100%;
  max-width: 128px;
  cursor: pointer;
  transition: all 0.5s linear;
}
.kit-desc.id:hover {
  color: #005eb8;
  font-family: TTNormsRegular, sans-serif;
}
.title.type {
  min-width: 90px;
  width: 100%;
  max-width: 90px;
}
.kit-desc.type {
  min-width: 80px;
  width: 100%;
  max-width: 80px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.title.status {
  min-width: 167px;
  width: 100%;
  max-width: 167px;
}
.kit-desc.status {
  min-width: 163px;
  width: 100%;
  max-width: 163px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.title.first-name {
  min-width: 140px;
  width: 100%;
  max-width: 150px;
}
.kit-desc.first-name {
  min-width: 135px;
  width: 100%;
  max-width: 135px;
}
.title.email {
  min-width: 160px;
  width: 100%;
  max-width: 185px;
}
.kit-desc.email {
  min-width: 170px;
  width: 100%;
  max-width: 170px;
  overflow: hidden;
}
.kit-desc.email span {
  width: 100%;
  max-width: 160px;
  overflow: hidden;
  display: inline-block;
}
.kit-desc.status span {
  width: 100%;
  max-width: 160px;
  overflow: hidden;
}
.kit-desc.first-name span {
  width: 100%;
  max-width: 140px;
  overflow: hidden;
  display: inline-block;
}
.title.date {
  min-width: 150px;
  width: 100%;
  max-width: 150px;
}
.kit-desc.date {
  min-width: 123px;
  width: 100%;
  max-width: 123px;
}
.title.shipdate {
  margin-left: 38px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  position: relative;
  cursor: pointer;
  gap: 10px;
}
.title.shipdate img {
  margin-top: -2px;
  max-width: 7px;
  height: 14px; 
}
.title.shipdate .down {
  transform: rotate(180deg);
}
.kit-desc.status-date {
  min-width: 140px;
  width: 100%;
  max-width: 140px;
}

.kits-item {
  display: flex;
  justify-content: space-between;
  position: relative;
  align-items: center;
  padding: 25px 30px;
  background-color: #fff;
  margin: 10px 0;
  border-radius: 5px;
}
.kits-item:hover {
  background-color: #e0e9f4;
}
.kits-item:hover > .kit-desc.date {
  min-width: 70px;
  width: 100%;
  max-width: 70px;
}
.kits-item:hover .remove-kit-btn {
  display: block;
}
.kits-item:hover .archive-kit-btn {
  display: block;
}
.archive-kit-btn {
  display: none;
  cursor: pointer;
}
.archive-kit-btn img{
  width: 20px;
}
.kits-item:hover .erase-kit-btn {
  display: block;
  padding-right: 6px;
}
.erase-kit-btn {
  display: none;
  cursor: pointer;
}

.erase-kit-btn img{
  width: 20px;
}

.kits-item:hover .login-kit-btn {
  display: block;
  margin-right: -8px;
}
.login-kit-btn {
  display: none;
  cursor: pointer;
}
.login-kit-btn img{
  width: 25px;
}
.kit-desc {
  color: #58595b;
  font-size: 12px;
  font-family: TTNormsLight, sans-serif;
}
.status-line {
  width: 100%;
  max-width: 140px;
  height: 3px;
  background-color: rgba(0, 70, 173, 0.3);
  margin: 5px 0 0 0;
  position: relative;
}
.status-line-bg {
  position: absolute;
  width: 50%;
  content: "";
  left: 0;
  top: 0;
  height: 100%;
  background-color: #005eb8;
}
.pogination {
  margin: 20px 0 0 0;
}
.remove-icon-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: transparent;
  border: none;
  padding: 0;
}
.onhold-btn {
  background-color: transparent;
  border: none;
  padding: 0;
  max-width: 15px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  outline: none;
  margin: 0 0 0 5px;
  cursor: pointer;
}
.onhold-btn-img {
  max-width: 100%;
}
.kit-actions {
  display: flex;
  align-items: center;
  gap: 10px;
}
.onHoldStatus {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
.title.result {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  position: relative;
  cursor: pointer;
  gap: 10px;
}
.kit-desc.result {
  min-width: 145px;
  width: 100%;
  max-width: 145px;
}
.title.result img {
  max-width: 7px;
  height: 14px;
  margin-top: -2px;
}
.title.result .down {
  transform: rotate(180deg);
}
// .status {
//   color: #cccdcf;
// }
.status.green {
  color: green;
}
.status.red {
  color: red;
}
.status.orange {
  color: orange;
}
.status.purple {
  color: #ac75bd;
}
.status.yellow {
  color: gold;
}
.remove-kit-btn {
  display: none;
  position: absolute;
  width: 18px;
  height: 18px;
  border: 1px solid #58595b;
  border-radius: 5px;
  right: 5px;
  cursor: pointer;
  &:before,
  &:after {
    content: "";
    display: block;
    position: absolute;
    height: 1px;
    width: 13px;
    background-color: #58595b;
    top: 50%;
    left: 50%;
    transform: translate(-50%) rotate(45deg);
  }
  &:after {
    transform: translate(-50%) rotate(-45deg);
  }
  &:hover {
    border-color: red;
    &:before,
    &:after {
      background-color: red;
    }
  }
}
@media print {
  .kits {
    display: none;
  }
}

.prob-count {
  text-align: right;
  color: #58595b;
  font-family: TTNormsLight, sans-serif;
  font-size: 13px;
  font-weight: bold;
}
.prob-count.custom {
  margin-bottom: 20px;
}

.kit-desc.nodata {
  width: 100%;
  overflow: hidden;
  display: inline-block;
  text-align: center;
}
.kits-item:hover .edit-kit-btn {
  display: block;
}
.edit-kit-btn {
  display: none;
  cursor: pointer;
  cursor: pointer;
  margin-right: -10px;
}
.edit-kit-btn img{
  width: 20px;;
}
</style>
